var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-datetime-picker',{staticClass:"datetimeBox",attrs:{"type":"date","min-date":_vm.minDate,"max-date":_vm.maxDate,"formatter":_vm.formatter},on:{"change":_vm.onChange,"confirm":_vm.onConfirm,"cancel":_vm.onCancel},model:{value:(_vm.currentDate),callback:function ($$v) {_vm.currentDate=$$v},expression:"currentDate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }